module.exports = __webpack_public_path__ + "static/media/light-theme-adblue-zone.4483d409.svg";